<template>
    <div class="my-avatar marginL201 clearfix" style="overflow: auto;">
        <div class="login-title h50">
            <span></span>
            我的头像
        </div>
        <div class="clearfix">
            <div class="show-avatar-l fl">
                <div class="wrapper" style="width:400px;height:300px;margin-left:50px;margin-top:20px;">
                    <vue-cropper
                            ref="cropper2"
                            :img="example2.img"
                            :outputSize="example2.size"
                            :outputType="example2.outputType"
                            :info="example2.info"
                            :canScale="example2.canScale"
                            :autoCrop="example2.autoCrop"
                            :autoCropWidth="example2.autoCropWidth"
                            :autoCropHeight="example2.autoCropHeight"
                            :fixed="example2.fixed"
                            :fixedNumber="example2.fixedNumber"
                    ></vue-cropper>
                </div>
                <span style="font-size: 14px;color:#afafaf;margin-left:50px;margin-top:20px;">仅支持JPG、GIF、PNG格式，文件小于5M。（使用高质量图片，可生成高清头像）</span>
                <div class="test-button">
                    <label class="btn" for="uploads" style="margin-left:50px;">选择图片</label>
                    <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);"
                           accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event, 1)">
                </div>
                <div class="show-preview"
                     :style="{'width': previews.w + 'px', 'height': previews.h + 'px',  'overflow': 'hidden', 'margin': '5px'}">
                    <div :style="previews.div">
                        <img :src="previews.url" :style="previews.img">
                    </div>
                </div>
            </div>
            <div class="show-avatar-r fl">
                <div class="w300 h300">
                    <p class="show-wrap-title  fontSize14 h72 lineH22 marginB30">您上传的图片将会自动生成三种尺寸头像，请注意中小尺寸的头像是否清晰。</p>
                    <div class="clearfix">
                        <div class="h260 fl">
                            <div class="w180 h180 circle" style="overflow: hidden;border-radius: 50%;">
                                <img :src="imgSrc" class="avatar-img-180 avatar-center">
                            </div>
                            <canvas class="canvas" ref="canvas" v-show="false"></canvas>
                            <p class="fontSize14 gray-color center">大尺寸头像，180*180像素</p>
                        </div>
                        <div class="h260 fl marginL50">
                            <div class="w70 marginB15">
                                <div class="w50 h50 marginL10 circle" style="overflow: hidden;border-radius: 50%;">
                                    <img :src="imgSrc" class="avatar-img-50 avatar-center">
                                </div>
                                <p class="fontSize12 gray-color center">中尺寸头像50*50像素(自动生成)</p>
                            </div>
                            <div class="w70">
                                <div class="w30 h30 marginL20 circle" style="overflow: hidden;border-radius: 50%;">
                                    <img :src="imgSrc" class="avatar-img-20 avatar-center">
                                </div>
                                <p class="fontSize12 gray-color center">小尺寸头像30*30像素(自动生成)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class=" blue-btn-wrap">
            <el-button type="primary" class="avatar-save-btn blue-btn h36 w200 marginT32 marginB30" @click="finish"
                       :loading="isSubmit">
                保存
            </el-button>
        </div>
    </div>
</template>
<style scoped>
    .content {
        margin: auto;
        max-width: 1200px;
        margin-bottom: 100px;
    }

    .test-button {
        display: flex;
        flex-wrap: wrap;
    }

    .btn {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #fff;
        border: 1px solid #c0ccda;
        color: #1f2d3d;
        text-align: center;
        box-sizing: border-box;
        outline: none;
        margin: 20px 10px 0px 0px;
        padding: 9px 15px;
        font-size: 14px;
        border-radius: 4px;
        color: #fff;
        background-color: #00b2b1;
        border-color: #00b2b1;
        transition: all .2s ease;
        text-decoration: none;
        user-select: none;
    }

    .des {
        line-height: 30px;
    }

    code.language-html {
        padding: 10px 20px;
        margin: 10px 0px;
        display: block;
        background-color: #333;
        color: #fff;
        overflow-x: auto;
        font-family: Consolas, Monaco, Droid, Sans, Mono, Source, Code, Pro, Menlo, Lucida, Sans, Type, Writer, Ubuntu, Mono;
        border-radius: 5px;
        white-space: pre;
    }

    .show-info {
        margin-bottom: 50px;
    }

    .show-info h2 {
        line-height: 50px;
    }

    /*.title, .title:hover, .title-focus, .title:visited {
        color: black;
    }*/
    .title {
        display: block;
        text-decoration: none;
        text-align: center;
        line-height: 1.5;
        margin: 20px 0px;
        background-image: -webkit-linear-gradient(left, #3498db, #f47920 10%, #d71345 20%, #f7acbc 30%, #ffd400 40%, #3498db 50%, #f47920 60%, #d71345 70%, #f7acbc 80%, #ffd400 90%, #3498db);
        color: transparent;
        -webkit-background-clip: text;
        background-size: 200% 100%;
        animation: slide 5s infinite linear;
        font-size: 40px;
    }

    .test {
        height: 500px;
    }

    .model {
        position: fixed;
        z-index: 10;
        width: 100vw;
        height: 100vh;
        overflow: auto;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
    }

    .model-show {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100vw;
        height: 100vh;
    }

    .model img {
        display: block;
        margin: auto;
        max-width: 80%;
        user-select: none;
        background-position: 0px 0px, 10px 10px;
        background-size: 20px 20px;
        background-image: linear-gradient(45deg, #eee 25%, transparent 25%, transparent 75%, #eee 75%, #eee 100%), linear-gradient(45deg, #eee 25%, white 25%, white 75%, #eee 75%, #eee 100%);
    }

    .c-item {
        display: block;
        padding: 10px 0;
        user-select: none;
    }

    @keyframes slide {
        0% {
            background-position: 0 0;
        }
        100% {
            background-position: -100% 0;
        }
    }
</style>
<script>
  import axiosUtil from "../../utils/AxiosUtils.js"
  import {Message} from "element-ui";

  export default {
    data() {
      return {
        crap: false,
        previews: {},
        lists: [
          {
            img: 'https://fengyuanchen.github.io/cropper/images/picture.jpg'
          },
          {
            img: 'http://ofyaji162.bkt.clouddn.com/touxiang.jpg'
          }
        ],
        option: {
          img: '',
          size: 1,
          full: false,
          outputType: 'png',
          canMove: true,
          fixedBox: false,
          original: false,
          canMoveBox: true
        },
        example2: {
          img: '',
          info: true,
          size: 1,
          canMove: true,
          canScale: false,
          canMoveBox: true,
          autoCrop: true,
          // 只有自动截图开启 宽度高度才生效
          autoCropWidth: 300,
          autoCropHeight: 250,
          // 开启宽度和高度比例
          fixed: true,
//                    fixedNumber: [4, 3]
        },
        downImg: '#',
        isSubmit: false,//头像是否保存成功
        checked: true,//+是否上传原图
        src: "",//上传头像不同尺寸预览的src地址
        imgSrc: JSON.parse(sessionStorage.getItem("loginInfo")).doc.docAvatar ? JSON.parse(sessionStorage.getItem("loginInfo")).doc.docAvatar : require("../../../images/icon-avatar.png"),//上传头像原图预览地址
        originalName: "",//上传的图片文件名，（接口需要）
        dragLeft: 25,//拖动的offsetLeft
        dragTop: 0,//拖动的offsetTop
        dragWidth: 250,//截取框拖动后的宽度，默认250
        dragHeight: 250,//截取框拖动后的高度，默认250
        isChangeSize: false,//是否正在更改选取框尺寸
      }
    },
    components: {},
    mounted: function () {
      // hljs.configure({useBR: true})
      var list = [].slice.call(document.querySelectorAll('pre code'))
      list.forEach((val, index) => {
        hljs.highlightBlock(val)
      })
    },
    computed: {
      // imgSrc(){
      //     return JSON.parse(sessionStorage.getItem("loginInfo")).doc.docAvatar ?JSON.parse(sessionStorage.getItem("loginInfo")).doc.docAvatar :require("../../../images/icon-avatar.png")
      // }
    },
    methods: {
      startCrop() {
        // start
        this.crap = true
        this.$refs.cropper.startCrop()
      },
      stopCrop() {
        //  stop
        this.crap = false
        this.$refs.cropper.stopCrop()
      },
      clearCrop() {
        // clear
        this.$refs.cropper.clearCrop()
      },
      // 实时预览函数
      realTime(data) {
        this.previews = data
      },
      finish() {
        let _this = this;
        _this.$refs.cropper2.getCropData((data) => {
          _this.src = data;
          _this.saveAvatar();
        })
      },
      down(type) {
        // event.preventDefault()
        var aLink = document.createElement('a')
        aLink.download = 'demo'
        // 输出
        if (type === 'blob') {
          this.$refs.cropper2.getCropBlob((data) => {
            this.downImg = data
            aLink.href = data
            aLink.click()
          })
        } else {
          this.$refs.cropper2.getCropData((data) => {
            
            this.downImg = data
            aLink.href = data
            aLink.click()
          })
        }
      },
      uploadImg(e, num) {
        //上传图片
        // this.option.img
        var file = document.getElementById("uploads")
        var files = e.target.files[0];
        
        this.originalName = files.name;
        if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG|BMP)$/.test(e.target.value)) {
          alert('图片类型必须是.gif,jpeg,jpg,png,bmp,GIF,JPG,PNG,BMP中的一种');
          return false
        }
        let data, reader = new FileReader();
        reader.readAsDataURL(files);
        reader.onload = () => {
          
          this.example2.img = reader.result;
        }
        //data = window.URL.createObjectURL(files[0]);
        //this.example2.img = data;
      },
      saveAvatar: function () {//保存头像
        let _this = this;//传递this,确保下方闭包函数this正确
        _this.isSubmit = true;
        let options = {
          base64: _this.src,
          fileName: _this.originalName,
          fileType: "IMAGE",
          module: "DOC",
          Service: "smarthos.system.file.upload.image.base64"
        };
        // axiosUtil(options, function(data){//上传图片
        //     let options = {
        //         docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
        //         docAvatar: data.obj.id,
        //         token: localStorage.getItem("token"),
        //         Service: "smarthos.user.doc.infomation.modify"
        //     };
        //     axiosUtil(options, function(data){
        //         _this.isSubmit = false;
        //         let userInfo = JSON.parse(sessionStorage.getItem("loginInfo"));
        //         userInfo.docAvatar = data.obj.docAvatar;
        //         _this.imgSrc=data.obj.docAvatar;
        //         localStorage.setItem("userInfo", JSON.stringify(userInfo));
        //         Message({
        //             showClose: true,
        //             message: "保存成功！",
        //             type: "success"
        //         });
        //     }, function () {
        //         _this.isSubmit = false;
        //     });
        // }, function(){
        //     _this.isSubmit = false;
        // });
        axiosUtil(options, function (data) {//上传图片
          let options = {
            docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
            docAvatar: data.obj.attaFileUrl,
            token: localStorage.getItem("token"),
            // Service: "smarthos.doc.info.modify"
            Service: "smarthos.user.doc.infomation.modify",
          };
          axiosUtil(options, function (data) {//重新获取用户信息
            // _this.isSubmit = false;
            let options = {
              docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
              token: localStorage.getItem("token"),
              Service: "smarthos.user.doc.get"
            };
            axiosUtil(options, function (data) {
              _this.isSubmit = false;
              let userInfo = JSON.parse(sessionStorage.getItem("loginInfo"));
              userInfo.doc.docAvatar = data.obj.doc.docAvatar;
              localStorage.setItem("userInfo", JSON.stringify(userInfo));
              Message({
                showClose: true,
                message: "保存成功！",
                type: "success"
              });
              _this.imgSrc = data.obj.doc.docAvatar;
            })


          }, function () {
            _this.isSubmit = false;
          });
        }, function () {
          _this.isSubmit = false;
        });
      }
    },
  }
</script>
